import { FC, useEffect, useState } from "react";
import {
  getBenchmarkByIdApi,
  getReviewByCompanyIdApi,
  getScoreByIdApi,
  getCompanyInfoByIdApi,
  getCompanyInfoV2Api,
} from "../../apis/company";
import { IBenchmark } from "../../interfaces/benchmark";
import { ICompanyInfo } from "../../interfaces/company";
import { IReview } from "../../interfaces/review";
import { IScore } from "../../interfaces/score";
import { ReachView } from "../../utils/core";
import Page404 from "../error/404";
import WidgetTemplate1 from "./website/widget-1";
import WidgetTemplate11 from "./website/widget-11";
import WidgetTemplate2 from "./website/widget-2";
import WidgetTemplate3 from "./website/widget-3";
import WidgetTemplate4 from "./website/widget-4";
import WidgetTemplate5 from "./website/widget-5";
import WidgetTemplate6 from "./website/widget-6";
import WidgetTemplate7 from "./website/widget-7";
import WidgetTemplate9 from "./website/widget-9";
import WidgetTemplate10 from "./website/widget-10";
import WidgetTemplate8 from "./website/widget-8";
import WidgetTemplate12 from "./website/widget-12";
import WidgetTemplate13 from "./website/widget-13";
import WidgetTemplate14 from "./website/widget-14";
import WidgetTemplate15 from "./website/widget-15";
import WidgetTemplate16 from "./website/widget-16";
import WidgetTemplate17 from "./website/widget-17";
import WidgetTemplate18 from "./website/widget-18";
import WidgetTemplate19 from "./website/widget-19";
import WidgetTemplate20 from "./website/widget-20";
import WidgetTemplate21 from "./website/widget-21";
import WidgetTemplate22 from "./website/widget-22";
import WidgetTemplate23 from "./website/widget-23";
import WidgetTemplate24 from "./website/widget-24";
import WidgetTemplate25 from "./website/widget-25";
import WidgetTemplate26 from "./website/widget-26";
import WidgetTemplate27 from "./website/widget-27";
import WidgetTemplate28 from "./website/widget-28";
import WidgetTemplate29 from "./website/widget-29";
import WidgetTemplate30 from "./website/widget-30";
import WidgetTemplate31 from "./website/widget-31";
import { ICompanyType } from "../../interfaces/companyV2";

const Widgets: FC<{
  templateId: number;
  businessId: string;
  theme: string;
  style?: string;
}> = ({ templateId, businessId, theme, style }) => {
  let [state, setState] = useState<{
    templateId: number;
    businessId: string;
    theme: string;
    style?: string;
    company: (ICompanyInfo & ICompanyType) | undefined;
    score: IScore | undefined;
    review: IReview | undefined;
    benchmark: IBenchmark | undefined;
    isError: boolean;
  }>({
    templateId: templateId,
    businessId: businessId,
    theme: theme,
    style: style,
    company: undefined,
    score: undefined,
    review: undefined,
    benchmark: undefined,
    isError: true,
  });

  const getCompanyInfoById = async (id: string): Promise<void> => {
    try {
      let companyDetail: any;
      if (state.templateId === 14) {
        const { data } = await getCompanyInfoV2Api();
        companyDetail = data;
      } else {
        const { data } = await getCompanyInfoByIdApi(id);
        companyDetail = data;
      }
      setState((prev) => ({
        ...prev,
        company: companyDetail,
        isError: false,
      }));
    } catch (e: any) {
      throw e;
    }
  };

  const getScoreById = async (id: string): Promise<void> => {
    try {
      const { data } = await getScoreByIdApi(id);

      setState((prev) => ({
        ...prev,
        score: data,
      }));
    } catch (e: any) {
      throw e;
    }
  };

  const getCompanyReviewById = async (id: string): Promise<void> => {
    try {
      const { data } = await getReviewByCompanyIdApi(id);

      setState((prev) => ({
        ...prev,
        review: data,
      }));
    } catch (e: any) {
      throw e;
    }
  };

  const getBenchmark = async (): Promise<void> => {
    try {
      const { data } = await getBenchmarkByIdApi();

      setState((prev) => ({
        ...prev,
        benchmark: data,
      }));
    } catch (e: any) {
      throw e;
    }
  };

  const initData = async (id: string) => {
    try {
      await getCompanyInfoById(businessId);
      if (state.templateId !== 14) {
        const tasks = [getScoreById(businessId), getCompanyReviewById(businessId)];
        // Industry Compare needs the primary-category benchmark too — the
        // other templates don't fetch it at all.
        if (state.templateId === 25) tasks.push(getBenchmark());
        await Promise.all(tasks);
      }
    } catch (error) {
      setState((prev) => ({
        ...prev,
        isError: true,
      }));
    }
  };
  useEffect(() => {
    initData(businessId);
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (!state.isError) {
      ReachView({ companyId: state.businessId, widgetId: state.templateId });
    }
    // eslint-disable-next-line
  }, [state.isError]);

  if (state.isError) return <Page404 />;

  switch (state.templateId) {
    case 1:
      return (
        <WidgetTemplate1
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
        />
      );
    case 2:
      return (
        <WidgetTemplate2
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
        />
      );
    case 3:
      return (
        <WidgetTemplate3
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
        />
      );
    case 4:
      return (
        <WidgetTemplate4
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
        />
      );
    case 5:
      return (
        <WidgetTemplate5
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
        />
      );
    case 6:
      return (
        <WidgetTemplate6
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
        />
      );
    case 7:
      return (
        <WidgetTemplate7
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
        />
      );
    case 8:
      return (
        <WidgetTemplate8
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
        />
      );
    case 9:
      return (
        <WidgetTemplate9
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
        />
      );
    case 10:
      return (
        <WidgetTemplate10
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
        />
      );
    case 11:
      return (
        <WidgetTemplate11
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
        />
      );
    case 12:
      return (
        <WidgetTemplate12
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
        />
      );
    case 13:
      return (
        <WidgetTemplate13
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
        />
      );
    case 14:
      return (
        <WidgetTemplate14
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
        />
      );
    case 15:
      return (
        <WidgetTemplate15
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
          style={state.style}
        />
      );
    case 16:
      return (
        <WidgetTemplate16
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
          style={state.style}
        />
      );
    case 17:
      return (
        <WidgetTemplate17
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
          style={state.style}
        />
      );
    case 18:
      return (
        <WidgetTemplate18
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
          style={state.style}
        />
      );
    case 19:
      return (
        <WidgetTemplate19
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
          style={state.style}
        />
      );
    case 20:
      return (
        <WidgetTemplate20
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
          style={state.style}
        />
      );
    case 21:
      return (
        <WidgetTemplate21
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
          style={state.style}
        />
      );
    case 22:
      return (
        <WidgetTemplate22
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
          style={state.style}
        />
      );
    case 23:
      return (
        <WidgetTemplate23
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
          style={state.style}
        />
      );
    case 24:
      return (
        <WidgetTemplate24
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
          style={state.style}
        />
      );
    case 25:
      return (
        <WidgetTemplate25
          company={state.company!}
          score={state.score!}
          review={state.review!}
          benchmark={state.benchmark}
          theme={state.theme}
          style={state.style}
        />
      );
    case 26:
      return (
        <WidgetTemplate26
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
          style={state.style}
        />
      );
    case 27:
      return (
        <WidgetTemplate27
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
          style={state.style}
        />
      );
    case 28:
      return (
        <WidgetTemplate28
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
          style={state.style}
        />
      );
    case 29:
      return (
        <WidgetTemplate29
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
          style={state.style}
        />
      );
    case 30:
      return (
        <WidgetTemplate30
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
          style={state.style}
        />
      );
    case 31:
      return (
        <WidgetTemplate31
          company={state.company!}
          score={state.score!}
          review={state.review!}
          theme={state.theme}
          style={state.style}
        />
      );
    default:
      return <Page404 />;
  }
};

export default Widgets;
